export const getOrderEligibilitiesMock =
{
  warnings: [
    {
      code: '39446',
      title: 'ORDER NOT ELIGIBLE FOR REFUND',
      detail: 'Please check nonEligibilityReason for more details'
    }
  ],
  data: {
    orderId: 'SRQTP4',
    cancelAndRefund: {
      refundStatus: 'notRefundable',
      nonEligibilityReasons: [
        {
          code: '001',
          title: 'ATC Voluntary Refund not allowed.'
        }
      ]
    }
  }
};

export const orderEligibilitiesMultipleBoundsDisrupt = {
  acknowledge: [
    {
      airBoundId: '2VFhf7bb9187424',
      disruption: {
        isEligible: true
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '39408',
            title: 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '39408',
            title: 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    },
    {
      airBoundId: '2VFhf74767015a5',
      disruption: {
        isEligible: true
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '39408',
            title: 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '39408',
            title: 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    }
  ],
  cancel: {
    isEligible: false
  },
  cancelAndRefund: {
    isEligible: false,
    nonEligibilityReasons: [
      {
        code: '001',
        title: 'ATC Voluntary Refund not allowed.'
      }
    ]
  },
  change: [
    {
      airBoundId: '1',
      flightIds: [
        'ST1'
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: '001',
          title: 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      nonEligibilityReason: 'flightChangeNotActivated'
    },
    {
      airBoundId: '2',
      flightIds: [
        'ST3'
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      nonEligibilityReason: 'flightChangeNotActivated'
    },
    {
      airBoundId: '3',
      flightIds: [
        'ST2'
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      nonEligibilityReason: 'flightChangeNotActivated'
    },
    {
      airBoundId: '4',
      flightIds: [
        'ST4'
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      nonEligibilityReason: 'flightChangeNotActivated'
    }
  ],
  flightReaccommodation: {
    acknowledge: [
      {
        airBoundId: '2VFhf7bb9187424',
        isEligible: true
      },
      {
        airBoundId: '2VFhf74767015a5',
        isEligible: true
      }
    ],
    change: [
      {
        airBoundId: '2VFhf7bb9187424',
        isEligible: true
      },
      {
        airBoundId: '2VFhf74767015a5',
        isEligible: true
      }
    ]
  },
  seatChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: '023',
          title: 'SEAT CHANGE NOT ALLOWED'
        }
      ]
    }
  ],
  serviceChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: '024',
          title: 'SERVICE CHANGE NOT ALLOWED'
        }
      ]
    }
  ]
};

export const orderEligibilitiesAcknwoledged = {
  acknowledge: [
    {
      airBoundId: '2QTNf7bf6115e90',
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '206',
            title: 'Bound has already been rebooked via SELF channel.'
          }
        ]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: '39408',
            title: 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      seats: {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    },
    {
      'airBoundId': '2QTNf30fc5ccd03',
      'disruption': {
        'isEligible': true
      },
      'waitlistConfirmation': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      seats: {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    }
  ],
  cancel: {
    'isEligible': false
  },
  cancelAndRefund: {
    'isEligible': false,
    'nonEligibilityReasons': [
      {
        'code': '001',
        'title': 'ATC Voluntary Refund not allowed.'
      }
    ]
  },
  change: [
    {
      'airBoundId': '2QTNf7bf6115e90',
      'flightIds': [
        'ST6'
      ],
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      'nonEligibilityReason': 'flightChangeNotActivated'
    },
    {
      'airBoundId': '2QTNf30fc5ccd03',
      'flightIds': [
        'ST4'
      ],
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      'nonEligibilityReason': 'flightChangeNotActivated'
    }
  ],
  flightReaccommodation: {
    'acknowledge': [
      {
        'airBoundId': '2QTNf7bf6115e90',
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '206',
            'title': 'Bound has already been rebooked via SELF channel.'
          }
        ]
      },
      {
        'airBoundId': '2QTNf30fc5ccd03',
        'isEligible': true
      }
    ],
    change: [
      {
        'airBoundId': '2QTNf7bf6115e90',
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '206',
            'title': 'Bound has already been rebooked via SELF channel.'
          }
        ]
      },
      {
        'airBoundId': '2QTNf30fc5ccd03',
        'isEligible': true
      }
    ]
  },
  seatChange: [
    {
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '023',
          'title': 'SEAT CHANGE NOT ALLOWED'
        }
      ]
    }
  ],
  serviceChange: [
    {
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '024',
          'title': 'SERVICE CHANGE NOT ALLOWED'
        }
      ]
    }
  ]
};

export const orderEligibilities = {
  'acknowledge': [
    {
      'airBoundId': '2VFhf8aec7d46bf',
      'disruption': {
        'isEligible': true
      },
      'waitlistConfirmation': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      'seats': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    },
    {
      'airBoundId': '2',
      'disruption': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '50006',
            'title': 'No disruption to acknowledge.'
          }
        ]
      },
      'waitlistConfirmation': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge waitlist confirmation functionality is not enabled.'
          }
        ]
      },
      'seats': {
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '39408',
            'title': 'Acknowledge seat functionality is not enabled.'
          }
        ]
      }
    }
  ],
  'cancel': {
    'isEligible': false
  },
  'cancelAndRefund': {
    'isEligible': true
  },
  'change': [
    {
      'airBoundId': '2VFhf8aec7d46bf',
      'flightIds': [
        'ST3'
      ],
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      'nonEligibilityReason': 'flightChangeNotActivated'
    },
    {
      'airBoundId': '2',
      'flightIds': [
        'ST2'
      ],
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '001',
          'title': 'FLIGHT CHANGE NOT ALLOWED'
        }
      ],
      'nonEligibilityReason': 'flightChangeNotActivated'
    }
  ],
  'flightReaccommodation': {
    'acknowledge': [
      {
        'airBoundId': '2VFhf8aec7d46bf',
        'isEligible': true
      },
      {
        'airBoundId': '2',
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '50006',
            'title': 'No disruption to acknowledge.'
          }
        ]
      }
    ],
    'change': [
      {
        'airBoundId': '2VFhf8aec7d46bf',
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '300',
            'title': 'Missing or invalid ticket.'
          }
        ]
      },
      {
        'airBoundId': '2',
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '217',
            'title': 'No disrupted bound is eligible.'
          }
        ]
      }
    ]
  },
  'nameChange': {
    'nameModification': [
      {
        'travelerIds': [
          'PT2'
        ],
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '001',
            'title': 'NAME UPDATE NOT ALLOWED'
          }
        ]
      }
    ],
    'passengerChange': [
      {
        'travelerIds': [
          'PT2'
        ],
        'isEligible': false,
        'nonEligibilityReasons': [
          {
            'code': '011',
            'title': 'PASSENGER CHANGE NOT ALLOWED'
          }
        ]
      }
    ]
  },
  'seatChange': [
    {
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '023',
          'title': 'SEAT CHANGE NOT ALLOWED'
        }
      ]
    }
  ],
  'serviceChange': [
    {
      'isEligible': false,
      'nonEligibilityReasons': [
        {
          'code': '024',
          'title': 'SERVICE CHANGE NOT ALLOWED'
        }
      ]
    }
  ]
};

export const orderEligibilitiesSingleBoundDisrupt = {
  "acknowledge": [
    {
      airBoundId: "2QTNf6da2697cdb",
      disruption: {
        isEligible: true
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge waitlist confirmation functionality is not enabled."
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge seat functionality is not enabled."
          }
        ]
      }
    },
    {
      airBoundId: "2",
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "50006",
            title: "No disruption to acknowledge."
          }
        ]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge waitlist confirmation functionality is not enabled."
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge seat functionality is not enabled."
          }
        ]
      }
    }
  ],
  cancel: {
    isEligible: false
  },
  cancelAndRefund: {
    isEligible: false,
    nonEligibilityReasons: [
      {
        code: "001",
        title: "ATC Voluntary Refund not allowed."
      }
    ]
  },
  change: [
    {
      airBoundId: "2QTNf6da2697cdb",
      flightIds: [
        "ST3"
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "001",
          title: "FLIGHT CHANGE NOT ALLOWED"
        }
      ],
      nonEligibilityReason: "flightChangeNotActivated"
    },
    {
      airBoundId: "2",
      flightIds: [
        "ST2"
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "001",
          title: "FLIGHT CHANGE NOT ALLOWED"
        }
      ],
      nonEligibilityReason: "flightChangeNotActivated"
    }
  ],
  flightReaccommodation: {
    acknowledge: [
      {
        airBoundId: "2QTNf6da2697cdb",
        isEligible: true
      },
      {
        airBoundId: "2",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "50006",
            title: "No disruption to acknowledge."
          }
        ]
      }
    ],
    change: [
      {
        airBoundId: "2QTNf6da2697cdb",
        isEligible: true
      },
      {
        airBoundId: "2",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "217",
            title: "No disrupted bound is eligible."
          }
        ]
      }
    ]
  },
  seatChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "023",
          title: "SEAT CHANGE NOT ALLOWED"
        }
      ]
    }
  ],
  serviceChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "024",
          title: "SERVICE CHANGE NOT ALLOWED"
        }
      ]
    }
  ]
};

export const orderEligibilitiesSingleBoundDisruptAck = {
  acknowledge: [
    {
      airBoundId: "2QTNf6da2697cdb",
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "213",
            title: "Bound already acknowledged."
          }
        ]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge waitlist confirmation functionality is not enabled."
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge seat functionality is not enabled."
          }
        ]
      }
    },
    {
      airBoundId: "2",
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "50006",
            title: "No disruption to acknowledge."
          }
        ]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge waitlist confirmation functionality is not enabled."
          }
        ]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "39408",
            title: "Acknowledge seat functionality is not enabled."
          }
        ]
      }
    }
  ],
  cancel: {
    isEligible: false
  },
  cancelAndRefund: {
    isEligible: false,
    nonEligibilityReasons: [
      {
        code: "001",
        title: "ATC Voluntary Refund not allowed."
      }
    ]
  },
  change: [
    {
      airBoundId: "2QTNf6da2697cdb",
      flightIds: [
        "ST3"
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "001",
          title: "FLIGHT CHANGE NOT ALLOWED"
        }
      ],
      nonEligibilityReason: "flightChangeNotActivated"
    },
    {
      airBoundId: "2",
      flightIds: [
        "ST2"
      ],
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "001",
          title: "FLIGHT CHANGE NOT ALLOWED"
        }
      ],
      nonEligibilityReason: "flightChangeNotActivated"
    }
  ],
  flightReaccommodation: {
    acknowledge: [
      {
        airBoundId: "2QTNf6da2697cdb",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "213",
            title: "Bound already acknowledged."
          }
        ]
      },
      {
        airBoundId: "2",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "50006",
            title: "No disruption to acknowledge."
          }
        ]
      }
    ],
    change: [
      {
        airBoundId: "2QTNf6da2697cdb",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "213",
            title: "Bound already acknowledged."
          }
        ]
      },
      {
        airBoundId: "2",
        isEligible: false,
        nonEligibilityReasons: [
          {
            code: "217",
            title: "No disrupted bound is eligible."
          }
        ]
      }
    ]
  },
  seatChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "023",
          title: "SEAT CHANGE NOT ALLOWED"
        }
      ]
    }
  ],
  serviceChange: [
    {
      isEligible: false,
      nonEligibilityReasons: [
        {
          code: "024",
          title: "SERVICE CHANGE NOT ALLOWED"
        }
      ]
    }
  ]
};

export const getOrderEligibilitiesOutboundDisruptMock =
{
  warnings: [
    {
      code: "39446",
      title: "ORDER NOT ELIGIBLE FOR REFUND",
      detail: "Please check nonEligibilityReason for more details"
    }
  ],
  data: {
    orderId: "S4PISF",
    cancelAndRefund: {
      refundStatus: "notRefundable",
      nonEligibilityReasons: [
        {
          code: "001",
          title: "ATC Voluntary Refund not allowed."
        }
      ]
    }
  }
};

export const orderEligibilitiesAcknwoledgedMultiBound = {
      "acknowledge": [
          {
              "airBoundId": "1",
              "disruption": {
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "213",
                          "title": "Bound already acknowledged."
                      }
                  ]
              },
              "waitlistConfirmation": {
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "39408",
                          "title": "Acknowledge waitlist confirmation functionality is not enabled."
                      }
                  ]
              },
              "seats": {
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "39408",
                          "title": "Acknowledge seat functionality is not enabled."
                      }
                  ]
              }
          },
          {
              "airBoundId": "2VFhf74767015a5",
              "disruption": {
                  "isEligible": true
              },
              "waitlistConfirmation": {
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "39408",
                          "title": "Acknowledge waitlist confirmation functionality is not enabled."
                      }
                  ]
              },
              "seats": {
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "39408",
                          "title": "Acknowledge seat functionality is not enabled."
                      }
                  ]
              }
          }
      ],
      "cancel": {
          "isEligible": false
      },
      "cancelAndRefund": {
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "ATC Voluntary Refund not allowed."
              }
          ]
      },
      "change": [
          {
              "airBoundId": "1",
              "flightIds": [
                  "ST4"
              ],
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "001",
                      "title": "FLIGHT CHANGE NOT ALLOWED"
                  }
              ],
              "nonEligibilityReason": "flightChangeNotActivated"
          },
          {
              "airBoundId": "2",
              "flightIds": [
                  "ST2"
              ],
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "001",
                      "title": "FLIGHT CHANGE NOT ALLOWED"
                  }
              ],
              "nonEligibilityReason": "flightChangeNotActivated"
          },
          {
              "airBoundId": "3",
              "flightIds": [
                  "ST3"
              ],
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "001",
                      "title": "FLIGHT CHANGE NOT ALLOWED"
                  }
              ],
              "nonEligibilityReason": "flightChangeNotActivated"
          }
      ],
      "flightReaccommodation": {
          "acknowledge": [
              {
                  "airBoundId": "1",
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "213",
                          "title": "Bound already acknowledged."
                      }
                  ]
              },
              {
                  "airBoundId": "2VFhf74767015a5",
                  "isEligible": true
              }
          ],
          "change": [
              {
                  "airBoundId": "2VFhf74767015a5",
                  "isEligible": true
              },
              {
                  "airBoundId": "2",
                  "isEligible": false,
                  "nonEligibilityReasons": [
                      {
                          "code": "213",
                          "title": "Bound already acknowledged."
                      }
                  ]
              }
          ]
      },
      "seatChange": [
          {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "023",
                      "title": "SEAT CHANGE NOT ALLOWED"
                  }
              ]
          }
      ],
      "serviceChange": [
          {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "024",
                      "title": "SERVICE CHANGE NOT ALLOWED"
                  }
              ]
          }
      ]
  }

export const orderEligibilitiesMutliBoundSingleDisrupt = {
  warnings: [
      {
          code: "39446",
          title: "ORDER NOT ELIGIBLE FOR REFUND",
          detail: "Please check nonEligibilityReason for more details"
      }
  ],
  data: {
      orderId: "VR8E86",
      cancelAndRefund: {
          refundStatus: "notRefundable",
          nonEligibilityReasons: [
              {
                  code: "001",
                  title: "ATC Voluntary Refund not allowed."
              }
          ]
      }
  }
}

export const orderEligibilitiesMutliBoundSingleDisruptAcknowledged = {
  "acknowledge": [
      {
          "airBoundId": "1",
          "disruption": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "213",
                      "title": "Bound already acknowledged."
                  }
              ]
          },
          "waitlistConfirmation": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge waitlist confirmation functionality is not enabled."
                  }
              ]
          },
          "seats": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge seat functionality is not enabled."
                  }
              ]
          }
      },
      {
          "airBoundId": "2",
          "disruption": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "50006",
                      "title": "No disruption to acknowledge."
                  }
              ]
          },
          "waitlistConfirmation": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge waitlist confirmation functionality is not enabled."
                  }
              ]
          },
          "seats": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge seat functionality is not enabled."
                  }
              ]
          }
      }
  ],
  "cancel": {
      "isEligible": false
  },
  "cancelAndRefund": {
      "isEligible": false,
      "nonEligibilityReasons": [
          {
              "code": "001",
              "title": "ATC Voluntary Refund not allowed."
          }
      ]
  },
  "change": [
      {
          "airBoundId": "1",
          "flightIds": [
              "ST3"
          ],
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "FLIGHT CHANGE NOT ALLOWED"
              }
          ],
          "nonEligibilityReason": "flightChangeNotActivated"
      },
      {
          "airBoundId": "2",
          "flightIds": [
              "ST2"
          ],
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "FLIGHT CHANGE NOT ALLOWED"
              }
          ],
          "nonEligibilityReason": "flightChangeNotActivated"
      }
  ],
  "flightReaccommodation": {
      "acknowledge": [
          {
              "airBoundId": "1",
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "213",
                      "title": "Bound already acknowledged."
                  }
              ]
          }
      ],
      "change": [
          {
              "airBoundId": "1",
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "213",
                      "title": "Bound already acknowledged."
                  }
              ]
          }
      ]
  },
  "seatChange": [
      {
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "023",
                  "title": "SEAT CHANGE NOT ALLOWED"
              }
          ]
      }
  ],
  "serviceChange": [
      {
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "024",
                  "title": "SERVICE CHANGE NOT ALLOWED"
              }
          ]
      }
  ]
}

export const orderEligibilitiesMutliBoundSingleDisruptAcknowledgedDom = {
  "acknowledge": [
      {
          "airBoundId": "2VFhf65fd689106",
          "disruption": {
              "isEligible": true
          },
          "waitlistConfirmation": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge waitlist confirmation functionality is not enabled."
                  }
              ]
          },
          "seats": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge seat functionality is not enabled."
                  }
              ]
          }
      },
      {
          "airBoundId": "3",
          "disruption": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "50006",
                      "title": "No disruption to acknowledge."
                  }
              ]
          },
          "waitlistConfirmation": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge waitlist confirmation functionality is not enabled."
                  }
              ]
          },
          "seats": {
              "isEligible": false,
              "nonEligibilityReasons": [
                  {
                      "code": "39408",
                      "title": "Acknowledge seat functionality is not enabled."
                  }
              ]
          }
      }
  ],
  "cancel": {
      "isEligible": false
  },
  "cancelAndRefund": {
      "isEligible": false,
      "nonEligibilityReasons": [
          {
              "code": "001",
              "title": "ATC Voluntary Refund not allowed."
          }
      ]
  },
  "change": [
      {
          "airBoundId": "1",
          "flightIds": [
              "ST1"
          ],
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "FLIGHT CHANGE NOT ALLOWED"
              }
          ],
          "nonEligibilityReason": "flightChangeNotActivated"
      },
      {
          "airBoundId": "2",
          "flightIds": [
              "ST3"
          ],
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "FLIGHT CHANGE NOT ALLOWED"
              }
          ],
          "nonEligibilityReason": "flightChangeNotActivated"
      },
      {
          "airBoundId": "3",
          "flightIds": [
              "ST2"
          ],
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "001",
                  "title": "FLIGHT CHANGE NOT ALLOWED"
              }
          ],
          "nonEligibilityReason": "flightChangeNotActivated"
      }
  ],
  "flightReaccommodation": {
      "acknowledge": [
          {
              "airBoundId": "2VFhf65fd689106",
              "isEligible": true
          }
      ],
      "change": [
          {
              "airBoundId": "2VFhf65fd689106",
              "isEligible": true
          }
      ]
  },
  "seatChange": [
      {
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "023",
                  "title": "SEAT CHANGE NOT ALLOWED"
              }
          ]
      }
  ],
  "serviceChange": [
      {
          "isEligible": false,
          "nonEligibilityReasons": [
              {
                  "code": "024",
                  "title": "SERVICE CHANGE NOT ALLOWED"
              }
          ]
      }
  ]
}

export const orderEligibilities2Adt1StuBoundDisrupt = {
  warnings: [
      {
          "code": "39446",
          "title": "ORDER NOT ELIGIBLE FOR REFUND",
          "detail": "Please check nonEligibilityReason for more details"
      }
  ],
  data: {
      orderId: "WAX6Q2",
      cancelAndRefund: {
          refundStatus: "notRefundable",
          nonEligibilityReasons: [
              {
                  "code": "001",
                  "title": "ATC Voluntary Refund not allowed."
              }
          ]
      }
  }
}